import { render, staticRenderFns } from "./IssuesTotalSummary.vue?vue&type=template&id=1273768e&scoped=true&"
import script from "./IssuesTotalSummary.vue?vue&type=script&lang=js&"
export * from "./IssuesTotalSummary.vue?vue&type=script&lang=js&"
import style0 from "./IssuesTotalSummary.vue?vue&type=style&index=0&id=1273768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273768e",
  null
  
)

export default component.exports